<template>
  <div class="about-us-page sub-page">
    <div class="top-image">
      <img :src="topImageSrc">
      <div class="top-mask"></div>
      <div class="top-text">
        <div class="main-title">{{ $dt(menuInfo, 'name') }}</div>
        <div class="breadcrumb" v-if="menuInfo.parent">{{ $dt(menuInfo.parent, 'name') }} > {{ $dt(menuInfo, 'name') }}</div>
      </div>
    </div>

    <div class="second-box">
      <div class="box-container">
        <div class="title-group">
          <h2 class="main-title">{{ $t('期待') }}</h2>
          <p class="address">{{ $t('地址') }}</p>
        </div>
        <div class="map-box" id="baiduMap"></div>

        <div class="contact-content">
          <div class="contact-left">
            <div class="school-name">{{ $t('上海松江区爱菊学校') }}</div>
            <div class="contact-item">
              <img class="phone-icon" src="../../../public/static/indexUse/phone.svg" />
              <div>{{ $t('小初部联系') }}</div>
            </div>
            <div class="contact-item">
              <img class="phone-icon" src="../../../public/static/indexUse/phone.svg" />
              <div>{{ $t('高中部联系') }}</div>
            </div>
          </div>
          <div class="contact-right">
            <div class="qrcode-item">
              <img class="qrcode-img" src="../../../public/static/indexUse/qrcode.png" />
              <p class="qrcode-desc">{{ $t('小初公众号二维码') }}</p>
            </div>
            <div class="qrcode-item">
              <img class="qrcode-img" src="../../../public/static/indexUse/qrcode.png" />
              <p class="qrcode-desc">{{ $t('高中公众号二维码') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultTopImage from '../../../public/static/customPage/defaultTop.png';

export default {
  name: "aboutUs",
  data() {
    return {
      map: null,
      menuInfo: {},
    };
  },
  computed: {
    topImageSrc() {
      const image = this.menuInfo.image;
      return image?.filePath ? this.$Dolphin.path.publicPath + image.filePath : defaultTopImage;
    }
  },
  methods: {
    queryMenu() {
      this.$ajax({
        url: '/portal/queryPageNotConfig',
        params: { link: 'aboutUs' },
      }).then(({ data, rows }) => {
        this.menuInfo = data;
      });
    },
    initMap() {
      // 确保 BMap 已加载
      if (typeof window.BMap === 'undefined') {
        console.error('百度地图 API 未加载成功，请检查 AK 是否正确');
        return;
      }
      // 目标地点经纬度（示例为上海松江区，你可以换成具体坐标）
      const point = new window.BMap.Point(121.169658, 31.051370);
      // 初始化地图
      this.map = new window.BMap.Map("baiduMap");
      this.map.centerAndZoom(point, 16); // 15是缩放级别
      // 添加地图控件
      this.map.addControl(new window.BMap.NavigationControl()); // 平移缩放控件
      this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      // 添加标记点
      const marker = new window.BMap.Marker(point);
      this.map.addOverlay(marker);
      // 可选：添加点击标记的信息窗口
      const infoWindow = new window.BMap.InfoWindow("上海市松江区文俊东路100号", {
        width: 200,
        height: 60,
        title: "学校地址"
      });
      marker.addEventListener("click", () => {
        this.map.openInfoWindow(infoWindow, point);
      });
    }
  },
  created() {
    this.queryMenu()
  },
  mounted() {
    this.initMap();
  },
  beforeUnmount() {
    if (this.map) {
      // this.map.destroy();
    }
  },
};
</script>

<style scoped lang="scss">
@use "./commonPageTop";

.about-us-page {
  width: 100%;

  .second-box {
    width: 100%;
    padding: 96px 0;
    box-sizing: border-box;

    .box-container {
      width: 1280px;
      margin: 0 auto;

      .title-group {
        text-align: center;

        .main-title {
          font-size: 32px;
          font-weight: bold;
          color: #003C82;
          margin: 0 0 16px 0;
          line-height: 45px;
        }

        .address {
          font-size: 18px;
          color: #333333;
          margin-bottom: 32px;
          line-height: 25px;
        }
      }

      .map-box {
        width: 100%;
        height: 400px;
        border-radius: 8px;
        margin-bottom: 48px;
        overflow: hidden;
      }

      .contact-content {
        margin-top: 68px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .contact-left {
          .school-name {
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            line-height: 33px;
            margin-bottom: 24px;
          }

          .contact-item {
            width: 588px;
            height: 96px;
            background: #ECF1FB;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            padding: 0 28px;
            font-size: 20px;
            color: #333;

            .phone-icon {
              width: 42px;
              height: 42px;
              margin-right: 24px;
            }
          }
        }

        .contact-right {
          display: flex;
          gap: 70px;

          .qrcode-item {
            text-align: center;

            .qrcode-img {
              width: 175px;
              height: 175px;
              object-fit: cover;
              margin-bottom: 12px;
            }

            .qrcode-desc {
              font-size: 14px;
              color: #333;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>
